import { SURVEY_DATA_SOURCE, SURVEY_EVENTS } from '@/packages/components/hook/useSurvey'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-survey-form', // 组件名
  type: 'component-business', // 组件类型
  label: '问卷表单', // 组件label
  icon: 'icon-xy-survey-form', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 750 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  radius: { type: Number, default: 0 }, // 曲度
  titleFontSize: { type: Number, default: 16 }, // 题目字体大小
  titleMarginTop: { type: Number, default: 10 }, // 题目上间距
  titleMarginBottom: { type: Number, default: 10 }, // 题目下间距
  titleMarginLeft: { type: Number, default: 0 }, // 题目左间距
  titleMarginRight: { type: Number, default: 0 }, // 题目右间距
  fontColor: { type: String, default: '#000' }, // 字体颜色
  tagFontColor: { type: String, default: '#000' }, // 标签字体颜色
  tagBackgroundColor: { type: String, default: '#c973df' }, // 标签背景颜色
  backgroundColor: { type: String, default: '#bac5ee' }, // 背景颜色
  backgroundSrc: { type: String, default: '' }, // 背景图片
  showIndex: { type: Boolean, default: false }, // 是否显示题目索引
  showValidateMsg: { type: Boolean, default: true }, // 是否显示校验信息
  showTag: { type: Boolean, default: true }, // 是否显示类型标签
  isCard: { type: Boolean, default: false }, // 是否为卡片样式
  cardPaddingTop: { type: Number, default: 0 }, // 卡片内边距-上
  cardPaddingBottom: { type: Number, default: 0 }, // 卡片内边距-下
  cardPaddingLeft: { type: Number, default: 0 }, // 卡片内边距-左
  cardPaddingRight: { type: Number, default: 0 }, // 卡片内边距-右
  cardBackgroundColor: { type: String, default: '#fff' }, // 卡片背景颜色
  cardBorderRadius: { type: Number, default: 0 }, // 卡片曲度
  // 活动配置
  activityId: { type: String, default: '' }, // 活动id
  questions: { type: Array, default: [] }, // 问题列表配置
  questionTypeList: { type: Array, default: [] }, // 问题类型列表配置
  dialogUUID: { type: String, default: '' } // 弹窗uuid
}

/**
 * 组件开放方法事件
 */
export const events = SURVEY_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = SURVEY_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-survey-form'
  }
]
